import { render, staticRenderFns } from "./CommunicationSettingInfo.vue?vue&type=template&id=e8995534"
import script from "./CommunicationSettingInfo.vue?vue&type=script&lang=js"
export * from "./CommunicationSettingInfo.vue?vue&type=script&lang=js"
import style0 from "./CommunicationSettingInfo.vue?vue&type=style&index=0&id=e8995534&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports